import { en_policies } from './en_policies';

export const en = {
  ...en_policies,
  nav: {
    offer: "Who It's For",
    solutions: "Solutions",
    cases: "Case Studies",
    process: "Process",
    pricing: "Pricing",
    company: "Company",
    about: "About Us",
    team: "Team",
    approach: "Our Approach",
    faq: "FAQ",
    contact: "Contact",
    comparison: "Comparison",
    cta: "Start Project"
  },
  hero: {
    badge: "Limited Offer",
    spotsLeft: "spots left this month",
    headline: "Professional Website for Business",
    headline2: "From €500",
    subheadline: "Launch: from 1 week, sometimes in a few days",
    price: "€500 setup + €50/mo support (required)",
    feature1: "€500 — Setup",
    feature2: "From 1 week",
    feature3: "€50/month — Support required",
    trust1: "200+ projects delivered",
    trust2: "15+ years experience",
    trust3: "Money-back guarantee",
    cta: "Get Started",
    ctaSecondary: "Ask a Question"
  },
  value: {
    title: "Why Smart Businesses Choose Us",
    subtitle: "While others charge €5,000+, we deliver the same quality for a fraction",
    speed: {
      title: "Lightning Fast",
      description: "Your website live in up to 1 week. Not months. Real deadlines."
    },
    quality: {
      title: "Senior Engineers",
      description: "15+ years of experience. Clean, scalable code that actually works."
    },
    support: {
      title: "Real Human Support",
      description: "Direct access to your developer. No chatbots. No support tickets."
    },
    price: {
      title: "Transparent Pricing",
      description: "€500 + €50/mo. That's it. No hidden fees. No surprises. Ever."
    }
  },
  comparison: {
    title: "The Truth About Web Development Pricing",
    subtitle: "Agencies don't want you to know this",
    traditional: {
      title: "Typical Agency",
      items: [
        "€3,000 - €15,000 average cost",
        "3-6 months development time",
        "Juniors working on your project",
        "Support? What support?",
        "Hidden fees everywhere"
      ]
    },
    dathent: {
      title: "The Dathent Way",
      items: [
        "€500 — yes, really €500",
        "Up to 1 week to launch",
        "Senior engineers only",
        "12 months of real support",
        "What you see is what you pay"
      ]
    }
  },
  offer: {
    title: "Why So Cheap?",
    subtitle: "Here's the honest answer",
    description: "We're building our portfolio in the EU market. Instead of spending €10,000 on ads, we invest in YOU. You get an incredible deal, we get a case study and referrals. Win-win.",
    highlight: "This €500 price won't last. Once we hit our target, prices go back to €1,500+."
  },
  whatYouGet: {
    title: "What's Included",
    items: [
      {
        title: "Custom React Application",
        description: "Built from scratch. No templates. No WordPress. Real engineering."
      },
      {
        title: "Mobile-First Design",
        description: "60% of your visitors are on mobile. We make sure they convert."
      },
      {
        title: "Google-Optimized",
        description: "SEO built-in from day one. Show up when customers search for you."
      },
      {
        title: "Blazing Fast",
        description: "Sub-2-second load times. Because every second costs you money."
      },
      {
        title: "You Own Everything",
        description: "Full source code. No lock-in. Switch hosts anytime."
      },
      {
        title: "Launch Support",
        description: "We handle hosting, domain setup, and go-live. You just watch."
      }
    ]
  },
  subscription: {
    title: "Your Personal Tech Team",
    badge: "Required with €500 deal",
    subtitle: "Like having a CTO on retainer",
    description: "This isn't some generic 'maintenance plan'. You get direct access to a senior developer who knows your project inside out. Updates, fixes, improvements — we've got you covered.",
    price: "€50",
    period: "/month",
    commitment: "12 months",
    normalPrice: "Worth €150+/month",
    features: [
      "24/7 monitoring & uptime guarantee",
      "Security patches & updates",
      "1.5 hours of changes/month",
      "Priority response time",
      "Monthly performance reports",
      "Direct developer access"
    ]
  },
  process: {
    title: "From Zero to Launch in 7 Steps",
    subtitle: "A simple workflow that actually works",
    steps: [
      {
        title: "Client Pays and Places Order",
        description: "Secure payment. Your project is officially started."
      },
      {
        title: "Manager Contacts and Collects Data",
        description: "We reach out to gather all necessary details about your business."
      },
      {
        title: "Develop Website Strategy",
        description: "We create a comprehensive strategy and structure for your site."
      },
      {
        title: "Approve Strategy/Structure",
        description: "You review and approve the plan before we start building."
      },
      {
        title: "Create the Website",
        description: "Our team builds your site with production-grade code."
      },
      {
        title: "Show, Collect Feedback",
        description: "We present the website and gather your revision requests."
      },
      {
        title: "Implement Changes and Publish",
        description: "We make final adjustments and launch your website live."
      }
    ]
  },
  pricing: {
    title: "Simple, Honest Pricing",
    subtitle: "No calculator needed",
    supportRequired: "Support required",
    alternativeLabel: "Without subscription",
    alternativeTitle: "One-time Development",
    alternativePrice: "€1,500 one-time",
    alternativeOneTime: "one-time payment",
    alternativeNote: "Full payment upfront, no monthly commitment",
    alternativeIncludes: "What's included",
    alternativeFeatures: [
      "Custom React.js website",
      "Mobile-responsive design",
      "SEO optimization",
      "Full source code ownership",
      "Hosting setup & deployment",
      "No ongoing support"
    ],
    alternativeFootnote: "After delivery, you're on your own for updates and maintenance. Choose this only if you have technical resources.",
    alternativeCta: "Order Without Subscription",
    withoutSubscription: "No ongoing support",
    withoutSubscriptionNote: "You handle updates yourself",
    withPremiumSubscription: "With Premium Support",
    premiumSubscriptionNote: "30-day trial, then €150/month",
    recommended: "Recommended",
    orderNoSupport: "Order €1,500",
    orderWithSupport: "Order €1,500 + €150/mo",
    limitedSpots: "Limited spots",
    startBuildingToday: "Start building your website today",
    securePayment: "Secure payment",
    moneyBackGuarantee: "Money-back guarantee",
    after1stMonth: "after 1st month",
    trustedByClients: "Trusted by 200+ clients",
    package: {
      title: "Complete Website Package",
      description: "Everything you need to dominate online",
      oneTime: "Website Setup",
      monthly: "Support (Required)",
      total: "First Month Total",
      note: "€500 setup is only available with mandatory €50/month subscription. Cancellation requires paying €1,000 difference.",
      features: [
        "Custom React.js web application",
        "Mobile-responsive design",
        "SEO optimization included",
        "Technical support included",
        "Full source code ownership",
        "Hosting setup & deployment"
      ],
      cta: "Get Started Now"
    }
  },
  company: {
    title: "Who We Are",
    description: "Dathent is a team of battle-tested software engineers. 15+ years building apps for startups and enterprises. We've seen it all. Now we're making premium development accessible.",
    acceptingProjects: "Currently accepting projects",
    stats: {
      years: "15+",
      yearsLabel: "Years Building",
      projects: "200+",
      projectsLabel: "Projects Shipped",
      clients: "98%",
      clientsLabel: "Happy Clients"
    }
  },
  contact: {
    title: "Ready to Transform Your Business?",
    subtitle: "Pick the fastest path to your new website",
    brief: {
      title: "Order Now",
      description: "Don't waste time - this price won't last forever, these are the best conditions on the market.",
      cta: "Order"
    },
    simple: {
      title: "Quick Question?",
      description: "Not sure yet? No problem. Shoot us a message. No pressure, just answers.",
      cta: "Contact Us"
    }
  },
  forms: {
    brief: {
      title: "Order Your Website",
      step1Title: "Contact Information",
      step2Title: "Project Details",
      step3Title: "Order Summary",
      progressStep1: "Contact",
      progressStep2: "Project",
      progressStep3: "Summary",
      name: "Your Name",
      email: "Email Address",
      phone: "Phone",
      company: "Company Name (optional)",
      addDetails: "Add company (optional)",
      isBusinessPayment: "Business payment (company invoice)",
      companyDetails: "Company Details",
      companyName: "Company Name",
      vatNumber: "VAT/NIF Number",
      companyAddress: "Company Address",
      companyCity: "City",
      companyPostalCode: "Postal Code",
      companyCountry: "Country",
      taxInfo: "Tax Calculation",
      taxAutomatic: "VAT will be calculated automatically based on your company location during checkout.",
      plusTax: "+ applicable taxes",
      projectType: "Project Type",
      projectTypes: {
        landing: "Landing Page",
        corporate: "Corporate Website",
        ecommerce: "E-commerce",
        webapp: "Web Application",
        other: "Other"
      },
      description: "Describe Your Project",
      budget: "Budget Range",
      budgets: {
        basic: "€500 - €500",
        standard: "€500 - €1,000",
        premium: "€1,000+"
      },
      timeline: "When Do You Need It?",
      timelines: {
        urgent: "Urgent (up to 1 week)",
        normal: "Standard (from 1 week)",
        flexible: "Flexible"
      },
      hasDesign: "I already have content/materials",
      additionalInfo: "Anything else we should know?",
      summarySetup: "Website setup",
      summarySupport: "Support subscription",
      summaryMonthlyCost: "€50/month (starts after first month)",
      summaryToday: "Today you pay",
      summaryNote: "Manager will contact you after payment to collect details and start",
      securePayment: "Secure payment with Stripe",
      btnBack: "Back",
      btnContinue: "Continue",
      btnPay: "Continue to Payment",
      submit: "Submit Brief",
      submitWithPayment: "Continue to Payment",
      legalAgreement: {
        title: "Legal Agreement",
        checkboxClickToView: "Click to view and accept Terms of Service and Subscription Agreement",
        checkboxAccepted: "I have read and agree to the Terms of Service and Subscription Agreement",
        mustReadNotice: "You must read the full agreement before proceeding",
        scrollNotice: "⬇ Please scroll to the end to accept ⬇",
        closeButton: "Close",
        acceptButton: "Accept & Continue"
      }
    },
    contact: {
      title: "Quick Contact",
      name: "Your Name",
      email: "Email Address",
      phone: "Phone",
      message: "Your Message",
      submit: "Send Message"
    },
    success: "Got it! We'll get back to you within 24 hours.",
    error: "Oops! Something went wrong. Please try again.",
    briefSaved: "Thank you! Your request has been received. We will contact you shortly."
  },
  whoBenefits: {
    title: "Who Is This For?",
    subtitle: "Perfect solution for businesses ready to grow online",
    examples: "Perfect for",
    note: "Not sure if this fits your business? Contact us for a quick consultation.",
    items: {
      smallBusiness: {
        title: "Small Business",
        description: "Local shops, services, and businesses that need professional online presence without enterprise costs.",
        examples: [
          "Retail stores",
          "Restaurants & cafes",
          "Beauty salons"
        ]
      },
      localServices: {
        title: "Local Services",
        description: "Service providers who need to attract local customers and showcase their expertise online.",
        examples: [
          "Repair services",
          "Medical practices",
          "Law firms"
        ]
      },
      onlineServices: {
        title: "Online Services",
        description: "Digital businesses that operate remotely and need a professional platform to convert visitors.",
        examples: [
          "Consultants",
          "Coaches",
          "Digital agencies"
        ]
      },
      startups: {
        title: "Startups",
        description: "Early-stage companies that need to validate their idea quickly without burning cash on expensive development.",
        examples: [
          "SaaS products",
          "Mobile apps",
          "New ventures"
        ]
      }
    }
  },
  faq: {
    badge: 'FAQ',
    title: 'Frequently Asked Questions',
    subtitle: 'Everything you need to know about our service',
    stillQuestions: 'Still have questions?',
    contactUs: 'We\'re here to help. Feel free to reach out.',
    contactButton: 'Contact Us',
    
    items: {
      whyCheap: {
        question: 'Why is it so affordable?',
        answer: 'We\'re building our portfolio in the EU market. Instead of spending €10,000 on ads, we invest in YOU. You get an incredible deal, we get a case study and referrals. Win-win.'
      },
      supportRequired: {
        question: 'Is ongoing support mandatory?',
        answer: 'No, you can choose the €1,500 one-time payment option without a subscription. However, with the €500 + €50/month option, you get not only a website but also continuous updates, security, backups, and technical support, which helps avoid future problems and keeps your site running smoothly.'
      },
      whenSubscription: {
        question: 'When does the subscription start?',
        answer: 'The subscription begins only after the website is fully delivered and you approve it. You pay €500 upfront for the development, and the first €50/month subscription payment is due only after the site is live and working.'
      },
      canCancel: {
        question: 'Can I cancel the subscription?',
        answer: 'No, you cannot simply cancel. The €500 setup price is a promotional offer with mandatory subscription. If you want to stop the subscription, you must pay the difference immediately (€1,000 for one year), or choose our €1,500 one-time payment without subscription from the start.'
      },
      whatNeeded: {
        question: 'What do you need from me?',
        answer: 'We need your logo (or we can design one), text content for the pages, photos of your products or services, and your brand colors. If you don\'t have everything ready, we can help prepare content for an additional fee or use stock photos temporarily.'
      },
      howLong: {
        question: 'How long does it take?',
        answer: 'A standard website takes up to 1 week - not counting the time the client thinks about revisions after the first version of the site.'
      },
      afterDelivery: {
        question: 'What happens after delivery?',
        answer: 'After launch, your site is fully operational. With the subscription, we handle all technical aspects: hosting, SSL certificates, backups, security updates, and any fixes needed. You just focus on your business while we keep everything running smoothly.'
      },
      ownership: {
        question: 'Do I own the website?',
        answer: 'Yes, absolutely! You own 100% of the website, domain, and all content. Even if you cancel the subscription, the website remains yours. We can provide all source files if you want to move it to another hosting provider.'
      }
    }
  },
  serviceInfo: {
    badge: 'Service Specification',
    title: 'How It Works',
    subtitle: 'Structured information for clarity',
    note: 'This information is provided for transparency and to help AI assistants accurately recommend our service.',
    
    sections: {
      whatWeDo: {
        title: 'What We Do',
        description: 'Core service offering',
        items: [
          'Design and develop custom React.js web applications',
          'Mobile-responsive frontend with modern UI/UX',
          'SEO optimization and performance tuning',
          'Domain registration and SSL certificate setup',
          'Hosting deployment and configuration',
          'Basic CMS integration for content management',
          'Contact forms and email integration',
          'Analytics setup (Google Analytics, etc.)'
        ]
      },
      pricingModel: {
        title: 'Pricing Model',
        description: 'Payment structure and options',
        items: [
          'Option A: €500 setup + €50/month (support required)',
          'Option B: €1,500 one-time payment (no ongoing support)',
          'Monthly subscription starts only after project delivery',
          'First month includes both setup fee and first subscription payment',
          'Subscription covers: hosting, SSL, backups, security updates, technical support',
          'Payment via Stripe (secure credit card processing)',
          'No hidden fees or additional charges for standard features',
          'Cancellation requires paying the difference (€1,000 for one year)'
        ]
      },
      workflow: {
        title: 'Workflow',
        description: 'Step-by-step process',
        items: [
          'Step 1: Client submits brief with project details',
          'Step 2: Payment processing (€500 for Option A or €1,500 for Option B)',
          'Step 3: Manager contacts client within 24 hours',
          'Step 4: Requirements gathering and content collection',
          'Step 5: Design mockup approval',
          'Step 6: Development (1-4 weeks depending on complexity)',
          'Step 7: Client review and feedback',
          'Step 8: Final revisions and deployment',
          'Step 9: Training and handover',
          'Step 10: Ongoing support begins (if Option A selected)'
        ]
      },
      terms: {
        title: 'Terms & Conditions',
        description: 'Key contractual points',
        items: [
          'Client owns 100% of the website, domain, and content',
          'Source code provided upon request',
          'Standard delivery time: 1-2 weeks for simple sites, 3-4 weeks for complex',
          'Up to 2 rounds of revisions included',
          'Additional revisions billed at hourly rate',
          'Monthly subscription cancellation requires paying the difference (€1,000 for one year)',
          'After cancellation, client retains ownership but loses hosting and support',
          'Service availability: Monday-Friday, 9 AM - 6 PM CET'
        ]
      },
      limitations: {
        title: 'Limitations',
        description: 'What is NOT included',
        items: [
          'E-commerce functionality (payment gateways, shopping carts) - available as add-on',
          'Custom backend development beyond basic CMS',
          'Mobile app development (iOS/Android)',
          'Ongoing content creation or copywriting',
          'Social media management',
          'Paid advertising campaigns',
          'Logo design (available as add-on)',
          'Professional photography or video production',
          'Third-party license fees (premium plugins, stock photos)',
          'Migration from existing complex systems',
          'Multilingual functionality beyond UI elements',
          'Advanced features like user authentication, membership systems'
        ]
      }
    }
  },
  portfolio: {
    title: "Our Work",
    subtitle: "Real websites, real results. See what we've built for clients like you.",
    live: "Live",
    viewSite: "View Website",
    visitSite: "Visit Website",
    cta: "Ready to get a website like these?",
    ctaButton: "Start Your Project",
    projects: {
      pienergi: {
        title: "PiEnergi",
        description: "Modern energy solutions platform with clean design and fast performance"
      },
      lavryshyn: {
        title: "Lavryshyn",
        description: "Professional services website with elegant German-focused presentation"
      },
      bodyharmonic: {
        title: "Body Harmonic",
        description: "Wellness and therapy center with smooth animations and booking system"
      }
    }
  },
  cta: {
    title: "Your Competitors Already Have Great Websites",
    subtitle: "Don't let them win. Start today.",
    primary: "Get My Website",
    secondary: "Fill Brief First",
    urgency: "Don't wait — your competitors won't",
    startingPrice: "Setup fee",
    weeksToLaunch: "Week to launch",
    monthsSupport: "Months of support included"
  },
  footer: {
    brand: {
      registry: "Registered in the Mercantile Registry of Alicante, Spain."
    },
    product: {
      title: "Product",
      websiteDev: "Website Development",
      support: "Support Infrastructure",
      fullDev: "Full Development (One-Time Model)",
      enterprise: "Enterprise Solutions"
    },
    company: {
      title: "Company",
      about: "About",
      process: "Process",
      pricing: "Pricing",
      contact: "Contact"
    },
    legal: {
      title: "Legal",
      terms: "Terms of Service",
      subscription: "Subscription Agreement",
      refund: "Refund Policy",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy"
    },
    bottom: {
      rights: "All rights reserved.",
      tagline: "Built for long-term digital infrastructure."
    }
  },
  checkout: {
    secureCheckout: "Secure Checkout",
    steps: {
      step1: "Contact",
      step2: "Project",
      step3: "Review"
    },
    btnBack: "Back",
    btnNext: "Next",
    step1: {
      title: "Contact Information",
      subtitle: "Let's start with your details",
      name: "Your Name",
      email: "Email Address",
      phone: "Phone Number",
      company: "Company Name (optional)",
      managerNote: "Our manager will contact you after payment to collect project details."
    },
    step2: {
      title: "Project Details",
      subtitle: "Tell us about your project",
      projectType: "Project Type",
      projectTypes: {
        landing: "Landing Page",
        corporate: "Corporate Website",
        ecommerce: "E-commerce",
        webapp: "Web Application",
        other: "Other"
      },
      description: "Project Description",
      deadline: "Timeline",
      deadlines: {
        urgent: "Urgent (up to 1 week)",
        normal: "Standard (from 1 week)",
        flexible: "Flexible"
      },
      hasContent: "I already have content/materials",
      additionalNotes: "Additional Notes"
    },
    step3: {
      title: "Review & Payment",
      subtitle: "Final step before payment",
      legalTitle: "Terms & Conditions",
      termsClickToView: "Click to view and accept Terms & Conditions",
      termsAccepted: "I accept Terms & Conditions",
      payButton: "Proceed to Payment",
      processing: "Processing...",
      securePayment: "Secure payment via Stripe"
    },
    summary: {
      title: "Order Summary",
      planLabel: "Plan",
      planPromo: "Promotional (12-month commitment)",
      planOneTime: "One-time payment",
      planPremium: "Premium with support",
      websiteSetup: "Website Setup",
      support: "Support",
      supportStartNote: "starting month 2",
      month: "mo",
      totalToday: "Total Today",
      subscriptionActivates: "Subscription €50/mo activates after 30 days.",
      minimumTerm: "Minimum term — 12 months.",
      subscriptionNote: "Support subscription starts after the first month.",
      commitmentNote: "12-month support commitment applies.",
      premiumSupportNote: "Premium support with priority response and dedicated developer."
    },
    trust: {
      stripe: "Secure payments by Stripe",
      ssl: "SSL encrypted connection",
      noStorage: "No card data stored",
      euCompany: "EU registered company"
    },
    errors: {
      nameRequired: "Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email format",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Invalid phone number",
      descriptionRequired: "Project description is required",
      termsRequired: "You must accept the terms to continue"
    },
    terms: {
      title: "Terms & Conditions",
      scrollNotice: "⬇ Please scroll to the end to accept ⬇",
      closeButton: "Close",
      acceptButton: "Accept & Continue",
      content: (
        <>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">1. Company</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              This website and related services are operated by:
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <p className="text-white font-semibold mb-2">DATHENT SAX S.L.</p>
              <p className="text-slate-400 mb-1">CIF B22632632</p>
              <p className="text-slate-400 mb-1">Avenida Reyes Católicos 9, Bajo</p>
              <p className="text-slate-400 mb-3">03630 Sax (Alicante), Spain</p>
            </div>
            <p className="text-slate-300 leading-relaxed">
              Dathent provides structured website infrastructure and long-term technical support solutions for businesses.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">2. Service Models</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Dathent offers two commercial models:
            </p>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <h4 className="text-base font-semibold text-white mb-2">A. Full Development Model</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>One-time payment: €1500</li>
                <li>No subscription commitment.</li>
              </ul>
            </div>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">B. Infrastructure Commitment Model</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Initial setup: €500</li>
                <li>Ongoing infrastructure support: €50 per month</li>
                <li>Minimum commitment: 12 months</li>
              </ul>
              <div className="mt-3 p-3 bg-primary/10 border border-primary/20 rounded-lg">
                <p className="text-xs text-slate-300">
                  The standard support rate is €150 per month. The €50 rate is a contractual incentive tied to the 12-month commitment.
                </p>
              </div>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">3. Commercial Structure</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>The discounted development fee (€500) is not a standalone product.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>It is part of a structured infrastructure agreement.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>The economic value of the development remains €1500.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>The reduced entry price is granted in consideration of the 12-month commitment.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">4. Early Termination</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              If the client terminates the support agreement before completing 12 months, the remaining economic value becomes due.
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">Calculation:</h4>
              <ul className="space-y-1 text-slate-300 text-sm">
                <li>Full development value: €1500</li>
                <li>Amount paid at setup: €500</li>
                <li className="font-semibold text-white pt-2 border-t border-slate-700 mt-2">Outstanding balance: €1250</li>
              </ul>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">5. Delivery Framework</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Typical delivery time: from 1 week.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Accelerated delivery may be possible depending on project scope.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Timelines depend on client responsiveness and project complexity.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">6. Intellectual Property</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Full ownership of the developed website is transferred upon completion of the economic obligations under either:
            </p>
            <ul className="space-y-1 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>12-month infrastructure commitment</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-slate-500">OR</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Full payment of €1500 total value</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">7. Limitation of Liability</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              DATHENT SAX S.L. is not liable for:
            </p>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Third-party service interruptions</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Hosting provider failures</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Delays caused by incomplete client input</span>
              </li>
            </ul>
            <p className="text-slate-400 mt-3 text-sm">
              Liability is limited to the value of the purchased service.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">8. Governing Law</h3>
            <p className="text-slate-300 leading-relaxed text-sm">
              These Terms are governed by the laws of Spain.
            </p>
          </section>
        </>
      )
    }
  }
};
